/*
 * footer
 */
import { Link, useLocation } from "@tanstack/react-router"
import { cn } from "@psychology/react-ui"
import type { ReactNode } from "react"

export type FooterProps = {
	copyright?: string
	copyrightHref?: string
	RightSide?: ReactNode
	whitelistPathnames?: string[]
	devMode?: boolean
	children?: ReactNode
	className?: string
}

export function Footer({
	copyright,
	copyrightHref,
	RightSide,
	whitelistPathnames,
	devMode = false,
	children,
	className,
}: FooterProps) {
	const location = useLocation()

	if (whitelistPathnames && !whitelistPathnames.includes(location.pathname)) {
		return null
	}

	return (
		<div
			className={cn([
				"bg-primary text-primary-foreground min-h-(--footer-height)! z-10 flex min-h-14 w-full items-center",
				className,
			])}
		>
			<div
				className={cn([
					"xs:flex-nowrap xs:justify-between flex h-full w-full flex-row flex-wrap items-center gap-2 px-4 py-2",
					RightSide ? "justify-between" : "justify-center",
				])}
			>
				{copyrightHref ? (
					<Link
						className={"xs:w-[210px] flex-1 xs:justify-start"}
						to={copyrightHref}
						target={"_blank"}
					>
						{copyright}
					</Link>
				) : (
					<div
						className={
							"xs:w-[210px] flex-1 xs:justify-start flex justify-center"
						}
					>
						{copyright}
					</div>
				)}
				<div
					className={
						"xs:w-fit xs:justify-start flex flex-1 w-full sm:justify-center gap-6"
					}
				>
					{children}
					{devMode && (
						<Link className={"text-inherit"} to={"/dev"}>
							Dev
						</Link>
					)}
				</div>
				{RightSide && (
					<div className={"xs:w-[210px] justify-end flex flex-1 flex-row"}>
						{RightSide}
					</div>
				)}
			</div>
		</div>
	)
}
